import { FieldErrors, UseFormRegister } from 'react-hook-form';
import { Grid, GridItem, Heading } from '@chakra-ui/react';
import { FormElementAutoCompleteSuggestion, MortgageCertificateFormFields } from 'src/@types';
import { DynamicInput, FormElementDynamicInputTyped } from '../../../../shared/form-elements';
import { mortgageCertificateFormFields } from '../config';
import FormElementAutoComplete from '../../../../shared/form-elements/form-element-auto-complete/form-element-auto-complete';
import { useEffect, useState } from 'react';
import { API } from '../../../../../services';
import { UseFormSetValue } from 'react-hook-form/dist/types/form';
import { validationMessages } from '../../../../shared/validation/validation-messages';
import { utilSortValues } from '../../../../../utils/sorting';

export const MortgageCertificateFinalizeSection = ({
  heading,
  register,
  setValue,
  values,
  errors
}: {
  heading: string;
  register: UseFormRegister<MortgageCertificateFormFields>;
  errors: FieldErrors<MortgageCertificateFormFields>;
  values: MortgageCertificateFormFields;
  setValue: UseFormSetValue<MortgageCertificateFormFields>;
}) => {
  const [offices, setOffices] = useState<FormElementAutoCompleteSuggestion[]>([]);

  const setOfficeIdValue = (officeId: number) => {
    //console.log(officeId);
    setValue('officeId', officeId.toString(), { shouldValidate: true });
  };

  useEffect(() => {
    const fetchOffices = async () => {
      try {
        const res = await API.get<{
          [key: number]: string;
        }>('office/getlist');
        const offices: FormElementAutoCompleteSuggestion[] = Object.entries(res)
          .map((office) => {
            //console.log(office);
            return {
              value: parseInt(office[0]),
              label: `${office[0]} - ${office[1]}`,
              sortOn: office[1]
            };
          })
          .sort(utilSortValues('sortOn', 'asc'));

        setOffices(offices);
      } catch (error) {
        console.log(error);
      }
    };

    //if (!offices.length) {
    fetchOffices().then((r) => r);
    //}
  }, []);

  return (
    <>
      <Heading size={`md`}>{heading}</Heading>
      <Grid
        templateColumns={{
          base: 'repeat(1, 1fr)',
          md: 'repeat(2, 1fr)'
        }}
        gap={4}>
        <GridItem colSpan={{ base: 1, md: 2 }}>
          <DynamicInput
            id={mortgageCertificateFormFields.officeId.fieldName}
            label={mortgageCertificateFormFields.officeId.label}
            type={mortgageCertificateFormFields.officeId.type}
            placeholder={mortgageCertificateFormFields.officeId.placeHolder}
            validation={{ required: validationMessages.required }}
            tooltip={mortgageCertificateFormFields.officeId.tooltip}
            error={errors.officeId}
            defaultValue={values.officeId}
            options={
              offices as unknown as {
                label: string;
                value: string;
              }[]
            }
            register={register}
            hint={mortgageCertificateFormFields.officeId?.hint}
          />
          <div className={`mt-2 relative`}>
            <FormElementAutoComplete
              suggestions={offices}
              onSelect={setOfficeIdValue}
              placeHolder={'Zoek op vestiging naam'}></FormElementAutoComplete>
          </div>
        </GridItem>

        <FormElementDynamicInputTyped<MortgageCertificateFormFields>
          formFields={mortgageCertificateFormFields}
          id={'issueDate'}
          register={register}
          errors={errors}
          values={values}
          options={{ required: true }}
        />
        <FormElementDynamicInputTyped<MortgageCertificateFormFields>
          formFields={mortgageCertificateFormFields}
          id={'consultantName'}
          register={register}
          errors={errors}
          values={values}
          options={{ required: true }}
        />
      </Grid>
    </>
  );
};
